import { render, staticRenderFns } from "./aboutDialog.vue?vue&type=template&id=45de0961&scoped=true&"
import script from "./aboutDialog.vue?vue&type=script&lang=js&"
export * from "./aboutDialog.vue?vue&type=script&lang=js&"
import style0 from "./aboutDialog.vue?vue&type=style&index=0&id=45de0961&prod&lang=scss&"
import style1 from "./aboutDialog.vue?vue&type=style&index=1&id=45de0961&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de0961",
  null
  
)

export default component.exports